import { Button, Tooltip } from "~/components/ui";
import { type FunctionComponent } from "react";
import { useQuickPrompts } from "~/hooks/use-quick-prompts";

interface QuickPromptsProps {
  onSelect: (prompt: string) => void;
}

export const QuickPrompts: FunctionComponent<QuickPromptsProps> = ({ onSelect }) => {
  const { prompts, isLoading } = useQuickPrompts();

  if (isLoading || !prompts.length) {
    return null;
  }

  return (
    <div className="hidden flex-wrap gap-2 sm:flex">
      {prompts.map(({ short, description, content }) => (
        <Tooltip key={short} title={description}>
          <Button onClick={() => onSelect(content)} className="rounded-2xl">
            {short}
          </Button>
        </Tooltip>
      ))}
    </div>
  );
};
